/* vtwin-cart.js — VTwinBikers Shopify 2.0 Theme JS */
'use strict';

(function () {

  /* ══════════════════════════════
     CART DRAWER
  ══════════════════════════════ */
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartFooter  = document.getElementById('cd-footer');
  const cartItems   = document.getElementById('cd-items');
  const cartCount   = document.getElementById('cd-count');
  const cartBadge   = document.getElementById('hdr-cart-badge');
  const cartClose   = document.getElementById('cd-close-btn');
  const subtotal    = document.getElementById('cd-subtotal');
  const affirmMo    = document.getElementById('cd-affirm-mo');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    loadUpsells();
  }
  function closeCart() {
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  const cartBtn = document.getElementById('hdr-cart-btn');
  if (cartBtn) cartBtn.addEventListener('click', openCart);

  /* Qty and remove buttons in drawer (event delegation) */
  if (cartItems) {
    cartItems.addEventListener('click', async function (e) {
      const qtyBtn = e.target.closest('.cd-qty-btn');
      const rmBtn  = e.target.closest('.cd-remove');
      if (qtyBtn) {
        const key   = qtyBtn.dataset.key;
        const delta = parseInt(qtyBtn.dataset.delta);
        const numEl = document.getElementById('cd-qty-' + key.replace(/:/g, '_'));
        const cur   = parseInt(numEl ? numEl.textContent : 1);
        await changeCart(key, Math.max(0, cur + delta));
        await refreshDrawer();
      }
      if (rmBtn) {
        await changeCart(rmBtn.dataset.key, 0);
        await refreshDrawer();
      }
    });
  }

  async function addToCart(variantId, qty, properties) {
    qty = qty || 1;
    const payload = { items: [{ id: parseInt(variantId), quantity: qty }] };
    if (properties) payload.items[0].properties = properties;
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) { console.error('Cart add failed'); return null; }
    await refreshDrawer();
    openCart();
    return res.json();
  }

  async function changeCart(key, qty) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  async function refreshDrawer() {
    const res  = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();
    updateCartUI(cart);
  }

  function updateCartUI(cart) {
    /* Count badges */
    [cartCount, cartBadge].forEach(el => {
      if (!el) return;
      el.textContent = el === cartCount ? '(' + cart.item_count + ')' : cart.item_count;
    });
    /* Shipping bar */
    updateShippingBar(cart.total_price);
    /* Subtotal */
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (affirmMo) affirmMo.textContent = money(Math.floor(cart.total_price / 12)) + '/mo';
    /* Footer */
    if (cartFooter) cartFooter.style.display = cart.item_count === 0 ? 'none' : '';
    /* Re-render items */
    renderItems(cart);
  }

  function renderItems(cart) {
    if (!cartItems) return;
    if (!cart.item_count) {
      cartItems.innerHTML = `<div class="cd-empty">
        <div class="cd-empty-icon" aria-hidden="true"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M3 4h3l2.2 10.5h10L20 7H7"/></svg></div>
        <div class="cd-empty-title">YOUR CART IS EMPTY</div>
        <div class="cd-empty-sub">Add some race-proven parts!</div>
        <a href="/collections/all" class="cd-empty-btn">SHOP NOW →</a>
      </div>`;
      return;
    }
    cartItems.innerHTML = cart.items.map(item => {
      const img    = item.image ? `<img class="cd-item-img" src="${item.image.replace('http:','https:')}&width=120" alt="${escHtml(item.product_title)}" width="80" height="80" loading="lazy">` : '';
      const vrnt   = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cd-item-variant">${escHtml(item.variant_title)}</div>` : '';
      const pClass = item.original_price !== item.final_price ? 'cd-price cd-price-sale' : 'cd-price';
      const was    = item.original_price !== item.final_price ? `<span class="cd-price-was">${money(item.original_price)}</span>` : '';
      const keyId  = item.key.replace(/:/g,'_');
      return `<div class="cd-item" id="cd-item-${keyId}">
        <a href="${item.url}" class="cd-item-img-wrap">${img}</a>
        <div class="cd-item-info">
          <div class="cd-item-vendor">${escHtml(item.vendor.toUpperCase())}</div>
          <a href="${item.url}" class="cd-item-name">${escHtml(item.product_title)}</a>
          ${vrnt}
          <div class="cd-item-price-row"><span class="${pClass}">${money(item.final_price)}</span>${was}</div>
          <div class="cd-item-btns">
            <div class="cd-qty">
              <button class="cd-qty-btn" data-key="${item.key}" data-delta="-1">−</button>
              <span class="cd-qty-num" id="cd-qty-${keyId}">${item.quantity}</span>
              <button class="cd-qty-btn" data-key="${item.key}" data-delta="1">+</button>
            </div>
            <button class="cd-remove" data-key="${item.key}">REMOVE</button>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  /* Tier thresholds (cents). Each tier visually fills the next third of the bar. */
  const TIER_T1 = 20000;   // $200  — FREE SHIPPING
  const TIER_T2 = 80000;   // $800  — Free shirt + hat
  const TIER_T3 = 180000;  // $1800 — VTwin Bikers Brand Kit

  function updateShippingBar(totalPrice) {
    const bar  = document.getElementById('cd-shipping-bar');
    if (!bar) return;
    const fill = bar.querySelector('.cd-ship-fill');
    const msg  = bar.querySelector('.cd-ship-msg');
    const tiers = bar.querySelectorAll('.cd-tier');

    let pct, message;
    if (totalPrice >= TIER_T3) {
      pct = 100;
      message = '<strong>ALL REWARDS UNLOCKED</strong> &mdash; Free shipping + Brand Kit (5 tees, 3 hats, pillow) shipping with your order';
    } else if (totalPrice >= TIER_T2) {
      pct = 66 + ((totalPrice - TIER_T2) / (TIER_T3 - TIER_T2)) * 34;
      const rem = money(TIER_T3 - totalPrice);
      message = `Free shipping + free t-shirt + hat unlocked. Spend <strong>${rem}</strong> more for the <strong>VTWIN BIKERS BRAND KIT</strong>`;
    } else if (totalPrice >= TIER_T1) {
      pct = 33 + ((totalPrice - TIER_T1) / (TIER_T2 - TIER_T1)) * 33;
      const rem = money(TIER_T2 - totalPrice);
      message = `<strong>FREE SHIPPING</strong> unlocked. Spend <strong>${rem}</strong> more for a <strong>free t-shirt + hat</strong>`;
    } else {
      pct = (totalPrice / TIER_T1) * 33;
      const rem = money(TIER_T1 - totalPrice);
      message = `Spend <strong>${rem}</strong> more for <strong>FREE SHIPPING</strong>`;
    }

    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    if (msg)  msg.innerHTML = message;

    if (tiers && tiers.length) {
      const breakpoints = [TIER_T1, TIER_T2, TIER_T3];
      tiers.forEach((t, i) => {
        if (totalPrice >= breakpoints[i]) t.classList.add('is-unlocked');
        else t.classList.remove('is-unlocked');
      });
    }
  }

  /* ────────── SMART FBT (Frequently Bought Together) ──────────
     Pulls recommendations for EVERY cart item, then aggressively
     de-duplicates so we never show the same rotor in 3 colors as
     "frequently bought together" — that was the old behavior.
     Algorithm:
       1. Fetch /recommendations for each cart item (parallel)
       2. Compute a "family key" from each candidate's handle so
          products from the same family (e.g. "lyndall-brakes-320mm
          -perimeter-rotor-machined-24-..." vs the gold/black variants)
          collapse into one entry.
       3. Skip products that are already in the cart, that are out
          of stock, or that share a family with a cart item.
       4. Score remaining candidates — boost different vendor (variety),
          on-sale items (better offer), in-stock with image.
       5. Render the top N unique families.
     Exposed at module scope so both drawer + cart page reuse it. */
  function familyKey(handle) {
    // Tokens of the handle: brand + product family. We take the first
    // 4-5 dash-separated tokens — empirically this nails the family
    // (e.g. "lyndall-brakes-320mm-perimeter-rotor") while leaving color
    // / size / SKU suffixes off.
    return (handle || '').split('-').slice(0, 5).join('-');
  }

  async function fetchRelated(productId, limit = 16) {
    try {
      const r = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      const d = await r.json();
      return d.products || [];
    } catch (e) { return []; }
  }

  function isAvailable(p) {
    if (!p.variants || !p.variants.length) return false;
    return p.variants.some(v => v.available !== false);
  }

  function scoreFor(p, cart) {
    let s = 0;
    // Different-vendor variety bonus
    if (!cart.items.some(it => (it.vendor || '').toLowerCase() === (p.vendor || '').toLowerCase())) s += 8;
    // Has image (no image = doesn't render well)
    if (p.images && p.images.length) s += 3;
    // On sale (compare_at_price > price) = actual offer
    const v = p.variants && p.variants[0];
    if (v && v.compare_at_price && parseInt(v.compare_at_price, 10) > parseInt(v.price, 10)) s += 12;
    // Reasonable price (avoid recommending $500+ accessories on a $40 cart)
    const cartTotal = cart.total_price; // cents
    const candPrice = (v && parseInt(v.price, 10)) || 0;
    if (candPrice <= cartTotal * 1.5) s += 4; // not absurdly more expensive
    return s;
  }

  // Returns up to `wanted` recommended products for the current cart.
  async function smartFbt(cart, wanted = 4) {
    if (!cart.items.length) return [];
    // Compute filters from cart contents.
    const cartFamilies = new Set(cart.items.map(it => familyKey(it.handle)));
    const cartProductIds = new Set(cart.items.map(it => String(it.product_id)));
    // Fetch up to first 3 cart items in parallel (one cart usually
    // has 1-3 distinct products; more than that is rare).
    const recLists = await Promise.all(
      cart.items.slice(0, 3).map(it => fetchRelated(it.product_id, 16))
    );
    // Merge + dedupe by handle family.
    const seenFamilies = new Set(cartFamilies);
    const seenIds = new Set(cartProductIds);
    const candidates = [];
    for (const list of recLists) {
      for (const p of list) {
        if (seenIds.has(String(p.id))) continue;
        if (!isAvailable(p)) continue;
        const fam = familyKey(p.handle);
        if (seenFamilies.has(fam)) continue;
        seenIds.add(String(p.id));
        seenFamilies.add(fam);
        candidates.push(p);
      }
    }
    // Score + sort + truncate.
    candidates.forEach(p => p.__score = scoreFor(p, cart));
    candidates.sort((a, b) => b.__score - a.__score);
    // Relevance guard: never pitch a $1,900 kit on a $35 tee. Cap suggestions at 4x the cart (min $150).
    const priceCap = Math.max((cart.total_price || 0) * 4, 15000);
    const priced = candidates.filter(p => { const v = p.variants && p.variants[0]; return !v || (parseInt(v.price, 10) || 0) <= priceCap; });
    return priced.slice(0, wanted);
  }

  /* ────────── Drawer FBT renderer ────────── */
  async function loadUpsells() {
    const grid = document.getElementById('cd-upsell-grid');
    const box  = document.getElementById('cd-upsell');
    if (!grid) return;
    const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart    = await cartRes.json();
    if (!cart.items.length) { if (box) box.style.display = 'none'; return; }
    const picks = await smartFbt(cart, 4);
    if (!picks.length) { if (box) box.style.display = 'none'; return; }
    if (box) box.style.display = 'block';
    // Rebuy-style card markup: image-left, info-right, sale strikethrough,
    // SAVE badge when on sale, prominent + ADD button.
    grid.innerHTML = picks.map(p => {
      const img   = imgUrl(p) ? `<img class="cd-upsell-img" src="${imgUrl(p).replace('http:','https:')}&width=200" alt="${escHtml(p.title)}" loading="lazy">` : '';
      const v     = p.variants[0];
      const price = money(parseInt(v.price, 10));
      const vid   = v.id;
      const compare = v.compare_at_price ? parseInt(v.compare_at_price, 10) : 0;
      const cur     = parseInt(v.price, 10);
      const onSale  = compare > cur;
      const saveAmt = onSale ? money(compare - cur) : '';
      const badge   = onSale ? `<span class="cd-upsell-badge">SAVE ${saveAmt}</span>` : '';
      const priceHtml = onSale
        ? `<span class="cd-upsell-price">${price}</span> <span class="cd-upsell-was">${money(compare)}</span>`
        : `<span class="cd-upsell-price">${price}</span>`;
      return `<div class="cd-upsell-card">
        <a href="/products/${p.handle}" class="cd-item-img-wrap">${badge}${img}</a>
        <div class="cd-upsell-info">
          <div class="cd-upsell-vendor">${escHtml(p.vendor.toUpperCase())}</div>
          <a href="/products/${p.handle}" class="cd-upsell-name">${escHtml(p.title)}</a>
          <div class="cd-upsell-price-row">${priceHtml}</div>
          <button class="cd-upsell-atc" data-variant="${vid}">+ ADD TO CART</button>
        </div>
      </div>`;
    }).join('');
    grid.querySelectorAll('.cd-upsell-atc').forEach(btn => {
      btn.addEventListener('click', () => addToCart(btn.dataset.variant, 1));
    });
  }
  // Expose for the cart-page rebuy block below to reuse.
  window.__vtbSmartFbt = smartFbt;

  /* Cart note save on blur */
  const noteInput = document.getElementById('cd-note-input');
  if (noteInput) {
    noteInput.addEventListener('blur', async function () {
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: this.value })
      });
    });
  }

  /* Expose addToCart globally */
  window.addToCart = addToCart;

  /* ══════════════════════════════
     MOBILE MENU
  ══════════════════════════════ */
  const mobMenu    = document.getElementById('mob-menu');
  const mobOverlay = document.getElementById('mob-overlay');
  const mobClose   = document.getElementById('mm-close');
  const hamburger  = document.getElementById('hdr-hamburger');

  function openMenu() {
    mobMenu.classList.add('is-open');
    mobOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    if (hamburger) hamburger.setAttribute('aria-expanded','true');
  }
  function closeMenu() {
    mobMenu.classList.remove('is-open');
    mobOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    if (hamburger) hamburger.setAttribute('aria-expanded','false');
  }
  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (mobClose)  mobClose.addEventListener('click', closeMenu);
  if (mobOverlay) mobOverlay.addEventListener('click', closeMenu);
  /* Logo in mob menu also closes it */
  const mmLogoLink = document.getElementById('mm-logo-link');
  if (mmLogoLink) mmLogoLink.addEventListener('click', closeMenu);

  /* Mobile sub-menus */
  document.querySelectorAll('.mm-link--parent').forEach(btn => {
    btn.addEventListener('click', function () {
      const subId = this.dataset.sub;
      const sub   = document.getElementById(subId);
      if (!sub) return;
      const isHidden = sub.hidden;
      /* Close all */
      document.querySelectorAll('.mm-sub').forEach(s => { s.hidden = true; });
      document.querySelectorAll('.mm-link--parent').forEach(b => b.classList.remove('is-active'));
      if (isHidden) {
        sub.hidden = false;
        this.classList.add('is-active');
      }
    });
  });

  /* ══════════════════════════════
     PREDICTIVE SEARCH
  ══════════════════════════════ */
  const searchPanel   = document.getElementById('search-panel');
  const searchOverlay = document.getElementById('search-overlay');
  const spInput       = document.getElementById('sp-input');
  const spClear       = document.getElementById('sp-clear');
  const spLive        = document.getElementById('sp-live');
  const spTrending    = document.getElementById('sp-trending');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.classList.add('is-open');
    searchOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    setTimeout(() => { if (spInput) spInput.focus(); }, 120);
  }
  function closeSearch() {
    searchPanel.classList.remove('is-open');
    searchOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  /* Open search triggers */
  ['hdr-search-open','hdr-mob-search-btn','hdr-mob-search-btn'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('click', openSearch);
  });
  /* Also open when clicking the fake input */
  document.querySelectorAll('.hdr-search-btn').forEach(el => el.addEventListener('click', openSearch));
  document.querySelectorAll('.hdr-mob-search-btn').forEach(el => el.addEventListener('click', openSearch));

  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
  if (spClear) spClear.addEventListener('click', () => {
    spInput.value = '';
    spInput.focus();
    if (spLive)     spLive.innerHTML = '';
    if (spTrending) spTrending.style.display = '';
    spClear.style.display = 'none';
  });

  /* Trending tag clicks */
  document.querySelectorAll('.sp-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      if (!spInput) return;
      spInput.value = tag.dataset.term || tag.textContent.trim();
      spInput.dispatchEvent(new Event('input'));
    });
  });

  /* Debounced predictive search */
  let searchTimer;
  if (spInput) {
    spInput.addEventListener('input', function () {
      const q = this.value.trim();
      if (spClear) spClear.style.display = q ? '' : 'none';
      clearTimeout(searchTimer);
      if (!q || q.length < 2) {
        if (spLive)     spLive.innerHTML = '';
        if (spTrending) spTrending.style.display = '';
        return;
      }
      if (spTrending) spTrending.style.display = 'none';
      if (spLive) spLive.innerHTML = '<div class="sp-loading"><span class="sp-spinner"></span> Searching...</div>';
      searchTimer = setTimeout(() => runSearch(q), 280);
    });
  }

  /* Smart search: tries the literal query first; if 0 results, falls back
     through several normalized variants (spaces removed, adjacent words
     merged, longest single word) so "dyno jet power vison" still finds the
     "Dynojet Power Vision". Stops at first variant that produces hits. */
  async function fetchSuggest(q) {
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag,body`;
    const res = await fetch(url);
    if (!res.ok) throw new Error('search ' + res.status);
    return res.json();
  }
  function searchHasResults(d) {
    const r = d && d.resources && d.resources.results;
    return r && ((r.products && r.products.length) || (r.collections && r.collections.length));
  }
  function buildSearchVariants(q) {
    const words = q.split(/\s+/).filter(Boolean);
    const variants = [];
    // 1. all spaces removed (catches "dyno jet" → "dynojet")
    if (words.length > 1) variants.push(words.join(''));
    // 2. progressively merge adjacent word pairs
    for (let i = 0; i < words.length - 1; i++) {
      const merged = [...words.slice(0, i), words[i] + words[i+1], ...words.slice(i+2)].join(' ');
      if (!variants.includes(merged)) variants.push(merged);
    }
    // 3. drop the shortest word (catches typo'd 3-letter words like "vison")
    if (words.length > 1) {
      const sorted = [...words].sort((a, b) => b.length - a.length);
      variants.push(sorted.slice(0, words.length - 1).join(' '));
    }
    // 4. longest word alone (last-resort partial match)
    if (words.length > 1) {
      const longest = [...words].sort((a, b) => b.length - a.length)[0];
      if (longest && longest.length >= 4 && !variants.includes(longest)) variants.push(longest);
    }
    return variants;
  }
  async function runSearch(q) {
    try {
      let data = await fetchSuggest(q);
      if (!searchHasResults(data)) {
        for (const variant of buildSearchVariants(q)) {
          try {
            const trial = await fetchSuggest(variant);
            if (searchHasResults(trial)) { data = trial; break; }
          } catch (_) { /* try next */ }
        }
      }
      renderSearch(data, q);
    } catch (err) {
      if (spLive) spLive.innerHTML = '<div class="sp-no-results">Search unavailable. Please try again.</div>';
    }
  }

  function renderSearch(data, q) {
    if (!spLive) return;
    const products    = data.resources.results.products    || [];
    const collections = data.resources.results.collections || [];

    if (!products.length && !collections.length) {
      spLive.innerHTML = `<div class="sp-no-results">No results for "<strong>${escHtml(q)}</strong>". <a href="/search?q=${encodeURIComponent(q)}&type=product" class="sp-view-all-btn" style="font-size:12px;padding:6px 12px;">View all →</a></div>`;
      return;
    }

    let html = '';

    if (products.length) {
      html += `<div class="sp-section"><div class="sp-label">PRODUCTS</div>`;
      products.slice(0, 5).forEach(p => {
        const img   = p.image ? `<img class="sp-prod-img" src="${p.image.replace('http:','https:')}" alt="${escHtml(p.title)}" width="56" height="56" loading="lazy">` : '<div class="sp-prod-img" style="display:flex;align-items:center;justify-content:center;font-size:22px;">🏍️</div>';
        const price = p.price ? formatMoneyFromString(p.price) : '';
        const hl    = escHtml(p.title).replace(new RegExp(escRegex(q),'gi'), m => `<mark>${m}</mark>`);
        html += `<a href="${p.url}" class="sp-prod-row" onclick="closeSearch()">
          <div class="sp-prod-thumb">${img}</div>
          <div class="sp-prod-info">
            <div class="sp-prod-vendor">${escHtml((p.vendor||'').toUpperCase())}</div>
            <div class="sp-prod-title">${hl}</div>
            ${price ? `<div class="sp-prod-price">${price}</div>` : ''}
          </div>
          <span class="sp-prod-arrow">→</span>
        </a>`;
      });
      html += '</div>';
    }

    if (collections.length) {
      html += `<div class="sp-section"><div class="sp-label">COLLECTIONS</div>`;
      collections.slice(0, 3).forEach(c => {
        html += `<a href="${c.url}" class="sp-coll-row" onclick="closeSearch()">${escHtml(c.title)}</a>`;
      });
      html += '</div>';
    }

    html += `<div class="sp-view-all"><a href="/search?q=${encodeURIComponent(q)}&type=product" class="sp-view-all-btn" onclick="closeSearch()">VIEW ALL RESULTS FOR "${escHtml(q.toUpperCase())}" →</a></div>`;
    spLive.innerHTML = html;
  }

  /* Expose closeSearch globally for inline onclick */
  window.closeSearch = closeSearch;

  /* ══════════════════════════════
     PRODUCT PAGE
  ══════════════════════════════ */

  /* Gallery thumbs */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  /* Variant select */
  const variantSel = document.getElementById('prod-variant-select');
  if (variantSel) {
    variantSel.addEventListener('change', function () {
      const opt     = this.options[this.selectedIndex];
      const price   = parseInt(opt.dataset.price   || 0);
      const compare = parseInt(opt.dataset.compare || 0);
      const avail   = opt.dataset.available === 'true';

      const priceEl   = document.getElementById('prod-price-display');
      const compareEl = document.getElementById('prod-compare-price');
      const saveEl    = document.getElementById('prod-save-badge');
      const atcBtn    = document.getElementById('prod-atc-btn');
      const stockEl   = document.getElementById('prod-stock-txt');
      const hiddenId  = document.querySelector('[name="id"]');

      if (priceEl)   priceEl.textContent   = money(price);
      if (hiddenId)  hiddenId.value         = this.value;
      if (compareEl) {
        compareEl.textContent   = compare > price ? money(compare) : '';
        compareEl.style.display = compare > price ? '' : 'none';
      }
      if (saveEl) {
        const saved = compare - price;
        saveEl.textContent   = saved > 0 ? `SAVE ${money(saved)}` : '';
        saveEl.style.display = saved > 0 ? '' : 'none';
      }
      if (atcBtn) {
        atcBtn.textContent = avail ? 'ADD TO CART' : 'SOLD OUT';
        atcBtn.disabled    = !avail;
      }
      if (stockEl) stockEl.textContent = avail ? 'IN STOCK' : 'OUT OF STOCK';
    });
  }

  /* Qty buttons */
  window.adjustQty = function (delta) {
    const input = document.getElementById('prod-qty-input');
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
  };

  /* ATC button: handled by the bundle-aware inline handler in sections/product-page.liquid.
     (2026-10-16: a second listener here added the item twice per click.) */

  /* Tabs */
  window.switchTab = function (btn, id) {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('is-active'));
    document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
    const panel = document.getElementById('tab-' + id);
    if (panel) panel.classList.add('is-active');
  };

  /* Load product recommendations */
  const relatedGrid = document.getElementById('related-prod-grid');
  const alsoItems   = document.getElementById('also-bought-items');
  if (relatedGrid || alsoItems) {
    const pidMeta = document.getElementById('prod-id-meta');
    if (pidMeta) {
      const pid = pidMeta.content;
      fetch(`/recommendations/products.json?product_id=${pid}&limit=5&intent=related`)
        .then(r => r.json())
        .then(data => {
          if (!data.products) return;
          if (relatedGrid) {
            relatedGrid.innerHTML = data.products.map(p => productCardHtml(p)).join('');
            relatedGrid.querySelectorAll('.pc-atc').forEach(btn => {
              btn.addEventListener('click', () => addToCart(btn.dataset.vid, 1));
            });
          }
          if (alsoItems) {
            alsoItems.innerHTML = data.products.slice(0, 4).map(p => {
              const img   = imgUrl(p) ? `<img src="${imgUrl(p).replace('http:','https:')}&width=120" alt="${escHtml(p.title)}" loading="lazy">` : '';
              const price = money(p.variants[0].price);
              return `<div class="also-item">
                <div class="also-img"><a href="/products/${p.handle}">${img}</a></div>
                <div class="also-info">
                  <div class="also-name">${escHtml(p.title)}</div>
                  <div class="also-price">${price}</div>
                  <button class="cd-upsell-atc" style="margin-top:6px;" onclick="addToCart(${p.variants[0].id},1)">+ ADD</button>
                </div>
              </div>`;
            }).join('');
          }
        });
    }
  }

  /* ══════════════════════════════
     COLLECTION PAGE
  ══════════════════════════════ */
  const filterDrawer  = document.getElementById('mob-filter-drawer');
  const filterOverlay = filterDrawer ? filterDrawer.querySelector('.mob-filter-overlay') : null;

  window.openFilter  = () => { if (filterDrawer) { filterDrawer.classList.add('is-open'); document.body.classList.add('no-scroll'); } };
  window.closeFilter = () => { if (filterDrawer) { filterDrawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } };
  if (filterOverlay) filterOverlay.addEventListener('click', window.closeFilter);

  /* Sort redirect */
  document.querySelectorAll('.sort-select').forEach(sel => {
    sel.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  /* Sidebar toggle */
  window.toggleSbSection = function (head) {
    const body   = head.nextElementSibling;
    const toggle = head.querySelector('.sb-toggle');
    if (!body) return;
    const hidden = body.style.display === 'none';
    body.style.display  = hidden ? '' : 'none';
    if (toggle) toggle.textContent = hidden ? '▼' : '▶';
  };

  /* View toggle */
  document.querySelectorAll('.view-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  /* ══════════════════════════════
     HERO SLIDESHOW
  ══════════════════════════════ */
  const slides = document.querySelectorAll('.hero-slide');
  const dots   = document.querySelectorAll('.hero-dot');
  let cur = 0, timer;
  function goSlide(n) {
    if (!slides.length) return;
    slides[cur].classList.remove('is-active');
    if (dots[cur]) dots[cur].classList.remove('is-active');
    cur = ((n % slides.length) + slides.length) % slides.length;
    slides[cur].classList.add('is-active');
    if (dots[cur]) dots[cur].classList.add('is-active');
  }
  function startTimer() { timer = setInterval(() => goSlide(cur + 1), 5500); }
  dots.forEach((d, i) => d.addEventListener('click', () => { goSlide(i); clearInterval(timer); startTimer(); }));
  if (slides.length > 1) startTimer();

  /* ══════════════════════════════
     CART PAGE REBUY
  ══════════════════════════════ */
  const cartRebuyGrid = document.getElementById('cart-rebuy-grid');
  if (cartRebuyGrid) {
    // Block is hidden in the markup; it is revealed only once >=1 recommendation
    // renders. Failure or empty result keeps it hidden (no "Loading..." text).
    const rebuyBox = document.getElementById('cart-rebuy') || cartRebuyGrid.closest('.cart-rebuy');
    const hideRebuy = () => { if (rebuyBox) { rebuyBox.hidden = true; rebuyBox.style.display = 'none'; } };
    // Hidden by default. Shown as soon as >=1 recommendation renders (even if
    // it arrives after the 3s mark, it just appears); on error/empty it stays hidden.
    const show = picks => {
      if (!picks || !picks.length) { hideRebuy(); return; }
      cartRebuyGrid.innerHTML = picks.map(p => productCardHtml(p, true)).join('');
      cartRebuyGrid.querySelectorAll('.pc-atc').forEach(btn => {
        btn.addEventListener('click', () => addToCart(btn.dataset.vid, 1));
      });
      if (rebuyBox) { rebuyBox.hidden = false; rebuyBox.style.display = ''; }
    };
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(r => r.json())
      .then(async cart => {
        if (!cart.items.length) return [];
        let picks = await smartFbt(cart, 6);
        // Shopify builds recommendations lazily: the first call can be empty. Retry once.
        if (!picks.length) { await new Promise(r => setTimeout(r, 1500)); picks = await smartFbt(cart, 6); }
        return picks;
      })
      .then(show)
      .catch(() => hideRebuy());
  }

  /* ══════════════════════════════
     HELPERS
  ══════════════════════════════ */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function formatMoneyFromString(str) {
    const num = parseFloat(str);
    return isNaN(num) ? str : money(num * 100);
  }
  /* recommendations JSON returns images as URL strings; products.json returns objects */
  function imgUrl(p) {
    const i = p && p.images && p.images[0];
    if (!i) return p && p.featured_image ? (p.featured_image.src || p.featured_image) : '';
    return typeof i === 'string' ? i : (i.src || '');
  }
  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function escRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  function productCardHtml(p, small) {
    const img   = imgUrl(p) ? `<img class="product-card__img" src="${imgUrl(p).replace('http:','https:')}&width=${small?200:400}" alt="${escHtml(p.title)}" loading="lazy">` : '';
    const price = money(p.variants[0].price);
    const vid   = p.variants[0].id;
    return `<div class="product-card">
      <a href="/products/${p.handle}"><div class="product-card__img-wrap">${img}</div></a>
      <div class="product-card__info">
        <div class="product-card__vendor">${escHtml(p.vendor.toUpperCase())}</div>
        <div class="product-card__title">${escHtml(p.title)}</div>
        <div class="product-card__price-row"><span class="product-card__price">${price}</span></div>
        <button class="product-card__atc pc-atc" data-vid="${vid}">ADD TO CART</button>
      </div>
    </div>`;
  }

  /* Init cart count on load */
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(r => r.json())
    .then(cart => {
      if (cartBadge) cartBadge.textContent = cart.item_count;
      if (cartCount) cartCount.textContent = '(' + cart.item_count + ')';
    });

  /* Global ESC key */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCart(); closeMenu(); closeSearch(); }
  });

})();

/* ══════════════════════════════════════════
   10% OFF EMAIL POPUP
   Bottom slide-in. Shows after ~10s OR 40% scroll OR exit-intent (desktop). Never locks scroll, never blocks the page. A dismiss hides it for 7 days (then it returns).
   ══════════════════════════════════════════ */
(function() {
  var popup = document.getElementById('vtb-popup');
  if (!popup) return;
  var STORAGE_KEY = 'vtb_popup_dismissed_at';
  var COOLDOWN_DAYS = 7;
  var DELAY_MS = 10000;
  var isPhone = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;

  function isOnCooldown() {
    try {
      var t = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (!t) return false;
      var ageDays = (Date.now() - t) / (1000 * 60 * 60 * 24);
      return ageDays < COOLDOWN_DAYS;
    } catch (e) { return false; }
  }
  function markDismissed() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }
  function open() {
    if (popup.classList.contains('is-open')) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    positionPopup(); setTimeout(positionPopup, 120); setTimeout(positionPopup, 400);
  }
  /* sit above the sticky add-to-cart bar on product pages */
  function positionPopup() {
    var h = 0, st = document.getElementById('sticky-atc');
    try { if (st && st.classList.contains('is-visible') && getComputedStyle(st).display !== 'none') h = st.offsetHeight; } catch (e) {}
    popup.style.setProperty('--vtb-pop-bottom', h + 'px');
  }
  window.addEventListener('scroll', function () { if (popup.classList.contains('is-open')) { setTimeout(positionPopup, 60); setTimeout(positionPopup, 350); } }, { passive: true });
  function close() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    markDismissed();
  }

  var SUBMIT_KEY = 'vtb_popup_submitted';
  var REVEALED_KEY = 'vtb_popup_revealed';
  var SESSION_KEY = 'vtb_popup_shown_session';
  var code = popup.getAttribute('data-code') || 'WELCOME10';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  // Bind close handlers
  popup.querySelectorAll('[data-popup-close]').forEach(function(el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
  });

  // Reveal the code after the signup round-trip (Shopify reloads the page with ?customer_posted=true)
  function reveal() {
    var form = popup.querySelector('.vtb-popup__form');
    var dec = popup.querySelector('.vtb-popup__form ~ .vtb-popup__decline');
    var sub = popup.querySelector('.vtb-popup__head .vtb-popup__sub');
    var rv = popup.querySelector('.vtb-popup__reveal');
    if (form) form.hidden = true;
    if (dec) dec.hidden = true;
    if (sub) sub.hidden = true;
    if (rv) rv.hidden = false;
    var ap = popup.querySelector('[data-popup-apply]');
    if (ap) ap.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    var cp = popup.querySelector('[data-popup-copy]');
    if (cp) cp.addEventListener('click', function() {
      try { navigator.clipboard.writeText(code); cp.textContent = 'COPIED'; } catch (e) {}
    });
    ls(REVEALED_KEY, String(Date.now()));
    open();
  }
  if (ls(SUBMIT_KEY) && !ls(REVEALED_KEY) && true) { reveal(); return; }

  var revAt = parseInt(ls(REVEALED_KEY) || '0', 10);
  if (revAt && (Date.now() - revAt) > 30 * 86400000) { try { localStorage.removeItem(REVEALED_KEY); localStorage.removeItem(SUBMIT_KEY); } catch (e) {} revAt = 0; }
  if (isOnCooldown() || revAt || ss(SESSION_KEY)) return;

  var form = popup.querySelector('.vtb-popup__form');
  if (form) form.addEventListener('submit', function() { ls(SUBMIT_KEY, String(Date.now())); });

  function autoOpen() { if (shown) return; shown = true; ss(SESSION_KEY, '1'); open(); }
  var shown = false;
  setTimeout(autoOpen, DELAY_MS);
  window.addEventListener('scroll', function onScroll() {
    if (shown) { window.removeEventListener('scroll', onScroll); return; }
    var de = document.documentElement;
    var max = (de.scrollHeight - window.innerHeight);
    if (max > 0 && (window.pageYOffset || de.scrollTop) / max >= 0.4) { window.removeEventListener('scroll', onScroll); autoOpen(); }
  }, { passive: true });
  if (!isPhone) document.addEventListener('mouseout', function(e) {
    if (!shown && e.relatedTarget == null && e.clientY <= 0) autoOpen();
  });
})();

/* ══════════════════════════════════════════
   YOU MAY ALSO LIKE — scroll arrows
   ══════════════════════════════════════════ */
(function() {
  var list = document.getElementById('also-bought-list');
  if (!list) return;
  document.querySelectorAll('.also-bought__arrow').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var dir = btn.dataset.dir === 'up' ? -1 : 1;
      list.scrollBy({ top: dir * 240, behavior: 'smooth' });
    });
  });
})();

/* ══════════════════════════════════════════
   RIDERS ALSO BOUGHT carousel arrows
   ══════════════════════════════════════════ */
(function() {
  var track = document.getElementById('rab-track');
  if (!track) return;
  document.querySelectorAll('.rab-arrow').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var card = track.querySelector('.rab-card');
      var step = card ? card.getBoundingClientRect().width + 16 : 200;
      var dir  = btn.dataset.rabDir === 'prev' ? -1 : 1;
      track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    });
  });
})();
